import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export default function Redirects() {
	const { pathname } = useLocation();
	const history = useHistory();

	useEffect(() => {
		// Rewrite urls starting with /v2 to /
		if (pathname.startsWith('/v2')) {
			history.replace(pathname.replace('/v2', ''));
		}
	}, []);

	return <></>;
}
